'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lowercaseKeys = require('lowercase-keys');

var _lowercaseKeys2 = _interopRequireDefault(_lowercaseKeys);

var _taxonomy = require('./taxonomy');

var _resetSearchParams = require('./lib/resetSearchParams');

var _resetSearchParams2 = _interopRequireDefault(_resetSearchParams);

var _encode = require('./lib/last-search-cookie/encode');

var _encode2 = _interopRequireDefault(_encode);

var _decode = require('./lib/last-search-cookie/decode');

var _decode2 = _interopRequireDefault(_decode);

var _canSaveSearch = require('./lib/can-save-search');

var _canSaveSearch2 = _interopRequireDefault(_canSaveSearch);

var _classificationCountsNeedUpdating = require('./lib/classification-counts-need-updating/classification-counts-need-updating');

var _classificationCountsNeedUpdating2 = _interopRequireDefault(_classificationCountsNeedUpdating);

var _stepCounts = require('./lib/step-counts');

var _stepCounts2 = _interopRequireDefault(_stepCounts);

var _job = require('./view-models/job/job');

var _job2 = _interopRequireDefault(_job);

var _searchResults = require('./view-models/search-results/search-results');

var _searchResults2 = _interopRequireDefault(_searchResults);

var _quickSearch = require('./view-models/quick-search/quick-search');

var _quickSearch2 = _interopRequireDefault(_quickSearch);

var _sortMode = require('./view-models/sort-mode/sort-mode');

var _sortMode2 = _interopRequireDefault(_sortMode);

var _worktype = require('./refinements/worktype');

var _worktype2 = _interopRequireDefault(_worktype);

var _salary = require('./refinements/salary');

var _salary2 = _interopRequireDefault(_salary);

var _daterange = require('./refinements/daterange');

var _daterange2 = _interopRequireDefault(_daterange);

var _classification = require('./refinements/classification');

var _classification2 = _interopRequireDefault(_classification);

var _sortmode = require('./refinements/sortmode');

var _sortmode2 = _interopRequireDefault(_sortmode);

var _classification3 = require('./refinements/clear/classification');

var _classification4 = _interopRequireDefault(_classification3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refine = function refine(paramsUnsanitised, newCounts, lastParamsUnsanitised, lastCounts, locale) {
  var params = (0, _lowercaseKeys2.default)(paramsUnsanitised);
  var lastParams = (0, _lowercaseKeys2.default)(lastParamsUnsanitised);

  var counts = (0, _stepCounts2.default)(params, newCounts, lastParams, lastCounts);
  var newParams = (0, _resetSearchParams2.default)(params);

  var clearRefinements = {
    clear: _extends({}, (0, _classification4.default)(params))
  };

  var taxonomy = (0, _taxonomy.getByLocale)(locale);

  return _extends({
    counts: counts
  }, (0, _worktype2.default)(taxonomy.workTypes, newParams, counts), (0, _salary2.default)(taxonomy.salaries, newParams, counts), (0, _daterange2.default)(taxonomy.dateRanges, newParams, counts), (0, _classification2.default)(taxonomy.classifications, newParams, counts), (0, _sortmode2.default)(taxonomy.sortModes, newParams), clearRefinements);
};

// Temporary hack...
// We can't use ES named exports until we remove the default export
refine.encodeLastSearchCookie = _encode2.default;
refine.decodeLastSearchCookie = _decode2.default;
refine.canSaveSearch = _canSaveSearch2.default;
refine.classificationCountsNeedUpdating = _classificationCountsNeedUpdating2.default;
refine.jobViewModel = _job2.default;
refine.searchResultsViewModel = _searchResults2.default;
refine.quickSearchViewModel = _quickSearch2.default;
refine.sortModeViewModel = _sortMode2.default;

exports.default = refine;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/index.js
 ** module id = 444
 ** module chunks = 0
 **/